import { ComponentFactoryResolver, Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[dynamicComponent]',
    standalone: false
})
export class DynamicComponents {
  constructor(public viewContainerRef: ViewContainerRef, public resolver: ComponentFactoryResolver) { }
}